<ng-container>
    <mat-checkbox class="example-margin" [checked]="checked" [disabled]="disabled" (change)="onChange($event)" color="primary">{{text}}</mat-checkbox>
</ng-container>
